import { getFunctions, httpsCallable } from "firebase/functions";

const MAX_TTS_LENGTH = 5000;

export async function fetchTextToSpeech(text) {
  if (!text) throw new Error('No text provided');
  
  const safeText = text.length > MAX_TTS_LENGTH ? text.slice(0, MAX_TTS_LENGTH) : text;
  
  try {
    const functions = getFunctions();
    const textToSpeechFunction = httpsCallable(
      functions,
      'textToSpeechHandler',
      { limitedUseAppCheckTokens: true }
    );
    
    const result = await textToSpeechFunction({ text: safeText });
    const { audioContent } = result.data;
    
    // Convert base64 back to ArrayBuffer
    const binaryString = atob(audioContent);
    const bytes = new Uint8Array(binaryString.length);
    for (let i = 0; i < binaryString.length; i++) {
      bytes[i] = binaryString.charCodeAt(i);
    }
    
    return bytes.buffer;
  } catch (error) {
    console.error('TTS callable function error:', error);
    throw new Error(error.message || 'TTS request failed');
  }
}
